import { createSelector } from "reselect";
import get from "lodash/get";
import { isArray, isEmpty } from "lodash";

const promoCodeDomain = state =>
  get(state?.api, "promocodePromotionDetails.data", {});
const systemWidePromoCodeDomain = state =>
  get(state?.api, "allSystemWidePromotion.data", {});
const promoCodeRequestedAtDomain = state =>
  get(state?.api, "promocodePromotionDetails.requestedAt", {});
const systemWidePromoCodeRequestedAtDomain = state =>
  get(state?.api, "allSystemWidePromotion.requestedAt", {});
const promoCodeErrorReasonDomain = state =>
  get(state.api, "promocodePromotionDetails.failure", "");
const isLoading = state =>
  get(state.api, "promocodePromotionDetails.loading", false);
const promocodeOrderPreviewDomain = state =>
  get(state?.api, "promocodeOrderPreview.data", {});

// ***************************************************************
// ****************** referral code selectors ********************
// ***************************************************************

export const promocodeOrderPreviewSelector = createSelector(
  promocodeOrderPreviewDomain,
  domain => domain
);

export const appliedOfferSelector = createSelector(
  promoCodeDomain,
  systemWidePromoCodeDomain,
  promoCodeRequestedAtDomain,
  systemWidePromoCodeRequestedAtDomain,
  promoCodeErrorReasonDomain,
  isLoading,
  (
    promoCode,
    systemWidePromoCode,
    promoCodeRequestedAt,
    systemWidePromoCodeRequestedAt,
    errorReason,
    loading
  ) => {
    let latestResponse = [];
    let finalOffers = [];
    let discountedPrice = 0;
    if (
      !isEmpty(promoCode) &&
      promoCodeRequestedAt > systemWidePromoCodeRequestedAt
    ) {
      latestResponse = isArray(promoCode.products) ? promoCode.products : [];
    } else {
      latestResponse = isArray(systemWidePromoCode.products)
        ? systemWidePromoCode.products
        : [];
    }

    const promo = [];
    const referral = [];
    const systemWide = [];
    let promoCodeValue = "";

    latestResponse.map(item => {
      discountedPrice = discountedPrice + item.finalPrice;
      if (item?.benefits?.length) {
        if (item?.promotionType === "promo") {
          promoCodeValue = get(item, "promoCode");
          promo.push(item);
        } else if (item?.promotionType === "referral") {
          promoCodeValue = get(item, "promoCode");
          referral.push(item);
        } else {
          systemWide.push(item);
        }
      }
    });
    finalOffers = [...promo, ...referral, ...systemWide];

    let promoCodeValid = promo.length > 0 || referral.length > 0;
    return {
      discountedPrice,
      finalOffers,
      promo,
      promoCodeValue,
      promoCodeValid,
      reason: !promoCodeValid ? get(errorReason, "errorCode") : null
    };
  }
);

export const promoCodeValue = createSelector(appliedOfferSelector, offer => {
  return {
    value: offer.promoCodeValue,
    valid: offer.promoCodeValid,
    promotionSummary: offer.promo.length ? offer.promo : offer.finalOffers,
    reason: offer.reason
  };
});
export const promoCodeBenefits = createSelector(appliedOfferSelector, offer => {
  return offer.finalOffers;
});

export const discountedPrice = createSelector(appliedOfferSelector, offer => {
  return offer.discountedPrice;
});
// ***************************************************************
// ****************** referral code makeSelect *******************
// ***************************************************************

export const makeSelectPromoCodeValue = () => promoCodeValue;
export const makeSelectJourneyManagerPromoCode = () => promoCodeBenefits;

export const makeSelectDiscountedPrice = () => discountedPrice;

export const makeSelectPromocodeOrderPreview = () =>
  promocodeOrderPreviewSelector;
